var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemDetailsBlueGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8553 10.5967L23.2817 0.190419C22.7836 -0.063473 22.2143 -0.063473 21.7136 0.190419L1.14095 10.5967C0.469413 10.9358 0.0259463 11.6823 0.00104219 12.5167C-0.022988 13.3494 0.370088 14.1274 1.01949 14.5192L21.5918 26.9632C21.8755 27.1358 22.1865 27.2203 22.4983 27.2203C22.8117 27.2203 23.1222 27.1358 23.4063 26.9632L43.9797 14.5192C44.6285 14.1274 45.022 13.3494 44.9985 12.5167C44.9703 11.6823 44.5279 10.9358 43.8553 10.5967Z",
    fill: "#273E52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1661 19.9069L22.4984 31.807L2.83397 19.9069C1.89257 19.3372 0.726881 19.7414 0.227926 20.8072C-0.274525 21.8725 0.081851 23.1943 1.02063 23.7625L21.593 36.21C21.8767 36.3815 22.1876 36.4669 22.4994 36.4669C22.8128 36.4669 23.1233 36.3827 23.4075 36.21L43.9809 23.7625C44.9175 23.1943 45.2734 21.8725 44.7739 20.8072C44.2711 19.7412 43.1046 19.337 42.1661 19.9069Z",
    fill: "#cccccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1661 28.4462L22.4984 40.3423L2.83397 28.4462C1.89257 27.876 0.726881 28.2807 0.227926 29.345C-0.274525 30.4103 0.081851 31.7334 1.02063 32.3008L21.593 44.7444C21.8767 44.917 22.1876 45.0024 22.4994 45.0024C22.8128 45.0024 23.1233 44.9181 23.4075 44.7444L43.9809 32.3008C44.9175 31.7334 45.2734 30.4105 44.7739 29.345C44.2711 28.2807 43.1062 27.8758 42.1661 28.4462Z",
    fill: "#cccccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemDetailsBlueGrey);
export default __webpack_public_path__ + "static/media/item-details-blue-grey.0019480a89d187bf3dcc9574a716d07a.svg";
export { ForwardRef as ReactComponent };